function appendQueryParameters(url, payload) {
  const requestUrl = new URL(url, window.location.origin);

  Object.entries(payload).forEach(([name, value]) => {
    requestUrl.searchParams.set(name, String(value));
  });

  return requestUrl.toString();
}

function resolveUrlParameters(url, parameters) {
  return Object.entries(parameters).reduce(
    (resolvedUrl, [name, value]) =>
      resolvedUrl
        .replaceAll(`{${name}}`, encodeURIComponent(value))
        .replaceAll(`:${name}`, encodeURIComponent(value)),
    url
  );
}

export function createFormRequest(api, payload, urlParameters = {}) {
  const urlTemplate = String(api?.url || api?.uri || "").trim();
  const method = String(api?.method || "").trim().toUpperCase();
  const configuredBody =
    api?.body && typeof api.body === "object" && !Array.isArray(api.body)
      ? api.body
      : {};

  if (!urlTemplate) {
    throw new Error("رابط إرسال النموذج غير موجود في ملف JSON.");
  }

  if (!method) {
    throw new Error("طريقة إرسال النموذج غير موجودة في ملف JSON.");
  }

  const url = resolveUrlParameters(urlTemplate, urlParameters);

  if (/[{:][a-zA-Z][a-zA-Z0-9_]*}?/.test(url)) {
    throw new Error("بعض قيم رابط إرسال النموذج غير متوفرة.");
  }

  const requestPayload = {
    ...configuredBody,
    ...payload,
  };

  if (method === "GET" || method === "HEAD") {
    return {
      url: appendQueryParameters(url, requestPayload),
      options: { method },
    };
  }

  return {
    url,
    options: {
      method,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestPayload),
    },
  };
}
